export type DeliveryType = {
  id: string;
  code?: string;
  name?: string;
  isFromManager: boolean;
  isActive: boolean;
  eType: number | null;
};

export enum eDeliveryType {
  Courier = 0,
  TakeAway = 1,
  DropShipping = 2,
  Post = 3,
  Transport = 4,
}
